module.exports = __webpack_public_path__ + "static/card-port-operations-alt-3f8f7b721e7ba49ea9a2b3f291bd96d2.jpg";